import { render, staticRenderFns } from "./Su2Surveys.vue?vue&type=template&id=d99e8858&scoped=true"
import script from "./Su2Surveys.vue?vue&type=script&lang=js"
export * from "./Su2Surveys.vue?vue&type=script&lang=js"
import style0 from "./Su2Surveys.vue?vue&type=style&index=0&id=d99e8858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99e8858",
  null
  
)

export default component.exports